import { forwardRef } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { PrivateDocumentCategory } from '@/shared/lib/sj-orm';
import { BaseProps } from '@/shared/types';

import { PrivateDocumentCategoryItem } from '../PrivateDocumentCategoryItem/index';

type PrivateDocumentSelectCategoryProps = BaseProps<{
  onSelect: (category: PrivateDocumentCategory) => void;
  filter?: PrivateDocumentCategory[];
}>;

export const categories = [
  PrivateDocumentCategory.PRIVATE_AGREEMENTS,
  PrivateDocumentCategory.PUBLIC_AGREEMENTS,
  PrivateDocumentCategory.INFORMATION_SHEETS,
  PrivateDocumentCategory.BANK_DOCUMENTS,
  PrivateDocumentCategory.PAYMENT_DOCUMENTS,
  PrivateDocumentCategory.POWERS,
  PrivateDocumentCategory.CORPORATE_DOCUMENTS,
  PrivateDocumentCategory.FAMILY_DOCUMENTS,
  PrivateDocumentCategory.OTHER,
];

export const SelectPrivateDocumentCategory = forwardRef<
  HTMLDivElement,
  PrivateDocumentSelectCategoryProps
>(({ onSelect, filter, ...props }, ref) => {
  return (
    <Container {...props} className="uikitScrollbarNone" ref={ref}>
      {categories
        .filter((item) => !filter || filter.includes(item))
        .map((category) => (
          <Item onClick={() => onSelect(category)} key={category}>
            <PrivateDocumentCategoryItem category={category} />
          </Item>
        ))}
    </Container>
  );
});

SelectPrivateDocumentCategory.displayName = 'SelectPrivateDocumentCategory';

const Container = styled.div`
  width: 280px;
  max-height: 435px;
  padding: 4px;
  border-radius: 16px;
  border: 1px solid ${COLORS.systemDark100};
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS.systemLight100};
`;

const Item = styled.div`
  height: 44px;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background: ${COLORS.systemLight200};
  }
`;
